import * as d3 from 'd3-selection'
import Tooltip from 'tooltip'

export default function () {
  let contents, tooltipRows // Can be overriden by the chart caller

  let draw = function (selection, dimensions, scalers, chart) {
    if (!chart.layout.hoverable()) {
      // We don't currently support hovering on these charts
      // See https://github.com/SpiderStrategies/Scoreboard/issues/37229
      return
    }

    selection.each(function (data) {
      let hover = d3.select(this)
                          .selectAll('rect.hover-rect')
                          .data([data])

      if (hover.size() && hover.node().__tooltip) {
        // Anytime we redraw hover support, clear the previous tooltip
        hover.node().__tooltip.destroy()
        delete hover.node().__tooltip
      }

      hover.enter()
           .append('rect')
             .attr('class', 'hover-rect hover-container')
             .merge(hover)
             .attr('width', Math.max(dimensions.width, 0))
             .attr('height', Math.max(dimensions.height, 0))
             .on('mousemove', function (e, data) {
               if (!this.__tooltip) {
                 chart.classed('hover', true)
                 this.__tooltip = new Tooltip(d3.select(chart.node().parentNode).attr('id') + '-tooltip', contents, tooltipRows)
               }

               this.__tooltip.chart = chart
               this.__tooltip.box = this

               this.__tooltip.update(e, data, scalers)

               this.__tooltip.show()
             })
             .on('mouseout', function () {
               chart.classed('hover', false)
               if (this.__tooltip) {
                 this.__tooltip.destroy()
                 delete this.__tooltip
               }
             })
    })
  }

  draw.destroy = function (svg) {
    // tooltip objects are stored on a node `.hover-container`
    // Find all plots in the chart and then their hover containers
    let hovers = svg.selectAll('g.plot')
                    .selectAll('.hover-container')

    hovers.each(function () {
      this.__tooltip?.destroy() // Destroy each tooltip
      delete this.__tooltip
    })
  }

  draw.contents = function (arg) {
    if (!arguments.length) {
      return contents
    }
    contents = arg
    return this
  }

  draw.tooltipRows = function (arg) {
    if (!arguments.length) {
      return tooltipRows
    }
    tooltipRows = arg
    return this
  }

  return draw
}
